export const name = "CURRENT_DATETIME";
export const summary = `Returns the current date and time as a \`DATETIME\` value.`;
export const reference = `
## CURRENT_DATETIME

Returns the current date and time as a \`DATETIME\` value.

\`\`\`
CURRENT_DATETIME([time_zone])
\`\`\`

### 

\`\`\`
CURRENT_DATETIME
\`\`\`


### Description

Returns the current time as a \`DATETIME\` object. Parentheses are optional when called with no arguments.

This function supports an optional \`time_zone\` parameter. See Time zone definitions for information on how to specify a time zone.

The current date and time value is set at the start of the query statement that contains this function. All invocations of \`CURRENT_DATETIME()\` within a query statement yield the same value.


### Return Data Type

\`DATETIME\`


### Example



\`\`\`
SELECT CURRENT_DATETIME() as now;

/*----------------------------*
 | now |
 +----------------------------+
 | 2016-05-19T10:38:47.046465 |
 *----------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/datetime_functions
`;
